<template>
  <div class="load-hide recharge">
    <!--<topbar></topbar>-->
    <!--<div class="top_title">充值</div>-->
    <div class="recharge_type" style="padding: 0.075rem 0.19rem 0;">
      <div v-on:click="choosePrice(item.id,index)" v-for="(item,index) in codeList" v-bind:class="{greenStyle:index==nowIndex,nochoosed:index!==nowIndex}"  class="typeList">
        <div class="left-text">¥ {{item.title}}<span class="middle-text">{{item.content}}</span></div>
        <!--<span v-bind:class="{choosed_price:index==nowIndex,nochoosed_price:index!==nowIndex}" ></span>-->
      </div>
    </div>
    <!--<div class="cfm"><input @click="confirm_recharge" type="button" value="确定"></div>-->
  </div>
</template>

<script>

import auth from '../../../lib/auth';
import constants from '../../../lib/constants';
export default {
  data(){
      return{
        codeList:[],
        page:1,
        size:20,
        queryId:'',
        choosedId:'',
        nowIndex:''
      }
  },
  mounted(){
    this.getPayCode()
  },
  methods: {
    choosePrice(id,index){
      this.choosedId = id;
      this.nowIndex = index;
      this.recharge(id);
    },
    confirm_recharge(){
      this.recharge(this.choosedId);
    },
      //获取支付码
    getPayCode(){
      this.$http.post(constants.API_HOST + constants.API_CARD_OPTION_LIST, {
          page:this.page,
          size:this.size
      }).then((result) => {
        let data = result.data;
        if (data.code === "200") {
          this.codeList = data.data.dataList;
          console.log(JSON.stringify(this.codeList),111);
        } else {
          this.$alert(data.data);
        }
      }, (error) => {
        error.data && this.$alert(error.data);
      });
    },
    //支付
    recharge(id){
      console.log(id,233);
      this.queryId = id;
      var ua = window.navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) == 'micromessenger'){
        this.$http.post(constants.API_HOST + constants.API_CARD_ECHARGE_ORDER, {
          pay_type:'weixin',
          echarge_option_id:this.queryId
        }).then((result) => {
          let data = result.data;
          if (data.code === "200") {
            console.log(data.data);
            var co_nbr = data.data.co_nbr;
            var price = data.data.price;
            this.weixinPay(co_nbr,price);
          } else {
            this.$alert(data.data);
          }
        }, (error) => {
          error.data && this.$alert(error.data);
        });
      }else{
          this.$alert("请在微信环境使用")
      }
    },
    repeatSearch(co_nbr){
      this.$http.post(constants.API_HOST + constants.API_ECHARGE_VIEW, {
        co_nbr:co_nbr
      }).then((result) => {
        let data = result.data;
        if (data.code === "200") {
          var status = data.data.status;
          if(status == "W" || status == "P"){
            this.repeatSearch(co_nbr)
          }else if(status == "PE"){
            this.$alert("支付异常",function(){
              router.push('card_qrcode')
            })
          }else if(status == "ES"){
            this.$alert("充值成功",function(){
              router.push('card_qrcode')
            })
          }else if(status == "EF"){
            this.$alert("充值失败",function(){
              router.push('card_qrcode')
            })                 }
        } else {
          this.$alert(data.data);
        }
      }, (error) => {
        error.data && this.$alert(error.data);
      })
    },
    weixinPay(co_nbr,price){
        var that = this;
      this.$http.post(constants.API_HOST +'/mapi/pay/pay_sign.htm', {
        co_nbr:co_nbr,
        pay_type:'weixin',
        pay_fee:price
      }).then((result) => {
        let data = result.data;
        if (data.code === "200") {
            console.log(data,23132);
          var n = data.data;
          if (typeof WeixinJSBridge != 'undefined') {
            WeixinJSBridge.invoke("getBrandWCPayRequest",{
                appId: n.app_id,
                timeStamp: n.time_stamp_str,
                nonceStr: n.nonce_str,
                package: n.package_str,
                signType: n.sign_type,
                paySign: n.pay_sign
              },
              function(o){
                if(o.err_msg == "get_brand_wcpay_request:ok"){
                    //支付完成
                  that.repeatSearch(co_nbr)
                }else if(o.err_msg == "get_brand_wcpay_request:cancel"){
                    //取消支付
                  router.push('main');
                }else if(o.err_msg == "get_brand_wcpay_request:fail"){
                    //支付失败
                  router.push('main');
                }
              }
            )}else{
              this.$alert("Error")
          }
          console.log(data.data);
        } else {
          this.$alert(data.data);
        }
      }, (error) => {
        error.data && this.$alert(error.data);
      });
    }
  }

}

</script>

<style>

  body,html{
    height:100%;
  }
  html {
    font-size:90px!important
  }
  @media only screen and (min-width:319px) {
    html {
      font-size:100px!important
    }
  }@media only screen and (min-width:370px) {
    html {
      font-size:117px!important
    }
  }@media only screen and (min-width:414px) {
    html {
      font-size:129px!important
    }
  }
  @media only screen and (min-width:639px) {
    html {
      font-size:200px!important
    }
  }
  .load_hide{
    height: 100%;
    background-color: #fff;
    /* background-image: url(http://style.cdn.juhaomai.net/style/images/site/sp/blue/online_newcard_bg.png); */
    background-size: cover;
    text-align: center;
    height: 100%;
    overflow: hidden;
    position: relative;
    padding: 0 13%;
  }
  .recharge{
    background: #eff3f6;
  }
  .recharge_type{
    background: #eff3f6;
  }
  .recharge .recharge_types img{
    width: 100%;
  }
  .typeList{
    margin-bottom: 15px;
    border: 1px solid #e1e1e1;
    padding: 0 0.186rem;
    height: 0.76rem;
    line-height: 0.76rem;
    display: flex;
    justify-content: space-between;
    background: #fff;
  }
  .left-text{
    z-index: 1;
    font-size: 0.18rem;
  }
  .middle-text{
    font-size: 0.12rem;
    margin-left: 0.1rem;
  }
  .top_title{
    width:100%;
    text-align: center;
    padding-top: 0.13rem;
    color: #000;
  }
  .choosed_price{
    background-image: url(../../../assets/img/bigicon.png);
    background-size: cover;
    width: 0.3rem;
    height: 0.3rem;
    background-repeat: no-repeat;
    margin-top: 0.22rem;
  }
  .nochoosed_price{
    background-image: none;
  }
  .cfm{
    padding: 0 0.15rem;
    position: fixed;
    bottom:3%;
    left:0;
    width: 100%;
  }
  .cfm input{
    width: 100%;
    height: 0.315rem;
    border: 0;
    border-radius: 0.05rem;
    margin: 0.14rem 0 0;
    font-size: 0.14rem;
    background: #3d9946;
    color: #fff;
  }
  .greenStyle{
    color: #3d9946;
    border: 1px solid #369946;
  }
  .nochoosed{
    color:#676a6c;
    border:1px solid #e1e1e1;
  }
</style>



// WEBPACK FOOTER //
// recharge.vue?28a831b4